import { Injectable } from '@angular/core';
import { OCPPService } from './ocpp.service';
import { HttpClient } from '@angular/common/http';
import { UpdateFirmwareRequest } from '../models/UpdateFirmwareRequest';
import { GetDiagnosticsRequest } from '../models/GetDiagnosticsRequest';

@Injectable()
export class FirmwareManagementService extends OCPPService {

    private UPDATE_FIRMWARE_PATH = '/update-firmware';
    private GET_DIAGNOSTICS_PATH = '/get-diagnostics';

    getProfileBasePath(): string {
        return '/operations/firmware-management';
    }

    constructor(private http: HttpClient) {
        super();
    }

    public updateFirmware(data: UpdateFirmwareRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.UPDATE_FIRMWARE_PATH, data);
    }

    public getDiagnostics(data: GetDiagnosticsRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.GET_DIAGNOSTICS_PATH, data);
    }

}


